module.exports = __webpack_public_path__ + "assets/BngMUXZYTXPIvIBgJJSb6ufD5qW54A-251a7d.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/BngMUXZYTXPIvIBgJJSb6ufD5qW54A.woff2
// module id = 872
// module chunks = 2